import avsandareModule from "@/store/modules/remiss/avsandareModule";
import mottagareModule from "@/store/modules/remiss/mottagareModule";

export default {
    namespaced: true,
    modules: {
        avsandare: avsandareModule,
        mottagare: mottagareModule,
    },
    mutations: {
        reset(state, { commit }) {
            const modules = state;

            Object.keys(modules).forEach((key) => {
                commit(`remiss/${key}/reset`, { commit }, { root: true });
            });
        },
    },
};
